import React, { useState } from 'react';
import '../../entrydoor.css';

const LaminatedGlass = ({ value, onChange, label = 'Laminated Glass' }) => {
    const [selectedLaminatedGlass, setSelectedLaminatedGlass] = useState(value || "");

    const handleLaminatedGlassChange = (e) => {
        setSelectedLaminatedGlass(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="LaminatedGlass">{label}</label>
            <select
                id="LaminatedGlass"
                value={selectedLaminatedGlass}
                onChange={handleLaminatedGlassChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Yes">{selectedLaminatedGlass === "Yes" ? "Yes ✔" : "Yes"}</option>
                <option value="No">{selectedLaminatedGlass === "No" ? "No ✔" : "No"}</option>
            </select>
        </div>
    );
};

export default LaminatedGlass;
